import { Component, Inject, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRoute,
  Router,
  UrlSegment,
  RouterLink,
} from '@angular/router';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { AuthService } from 'src/app/Core/auth/services/auth/auth.service';

// Removed: getCurrentLngData, getPageData - migrated to ngx-translate

import { isPlatformBrowser } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Navigation } from 'src/app/_utlis/navigateToLanding';
@Component({
    selector: 'app-not-found-page',
        standalone: true,
templateUrl: './not-found-page.component.html',
    styleUrls: ['./not-found-page.component.scss'],
    imports: [RouterLink, TranslatePipe]
})
export class NotFoundPageComponent {
  isSeller!: boolean;
  isBrowser: boolean;

  constructor(
    private storageService: StorageService,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
    private nav:Navigation

  ) {
    this.isSeller =
      this.storageService.userData && this.storageService.userData?.is_seller;
    const originalRoute = router.url;
    const decodedRoute = decodeURIComponent(router.url);
    if (originalRoute !== decodedRoute) {
      // console.log(`Query parameter " is encoded:`, originalRoute,"dec",decodedRoute);
      this.router.navigateByUrl(decodedRoute);
    } else {
      // console.log(`Query parameter  is not encoded:`, originalRoute);
    }
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  NavigateToLandingPage() {
    this.nav.NavigateToLanding();

  }
}
